module.exports = __webpack_public_path__ + "img/windmill-sidebar.4f869ae6.png";